module.exports = __webpack_public_path__ + "img/guanyuwomen_back.90389164.png";